var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemitPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70166 5.18417C7.13349 3.97783 8.98058 3.25 11 3.25C15.5567 3.25 19.25 6.94325 19.25 11.5C19.25 12.8264 18.9292 14.0758 18.3727 15.1859L15.9152 13.9576",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2983 17.8162C14.8665 19.0225 13.0194 19.7504 11 19.7504C6.44325 19.7504 2.75 16.0562 2.75 11.5004C2.75 10.174 3.07083 8.92454 3.62725 7.81445L6.08483 9.04279",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 6.91699V8.06283",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 16.0833V14.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2799 9.66667C13.2203 8.772 12.4824 8.0625 11.5731 8.0625H10.3172C9.42808 8.0625 8.7085 8.783 8.7085 9.67125C8.7085 10.4092 9.21083 11.0527 9.92583 11.2323L12.0736 11.7713C12.7895 11.951 13.2909 12.5945 13.2909 13.3324C13.2909 14.2216 12.5704 14.9412 11.6822 14.9412H10.4263C9.51516 14.9412 8.77725 14.2298 8.71858 13.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemitPaymentIcon);
export default __webpack_public_path__ + "static/media/remit-payment-icon.cff2ce7a4bcb1b637200b92bf841d635.svg";
export { ForwardRef as ReactComponent };